/* aurora-pdp.js — extracted from sections/aurora-pdp.liquid inline <script> blocks
   (2026-08-16). Loaded with defer at the end of the section. Block 1: entrance
   animations, video hero, tabs, sliders, 360 viewer (reads #apdp-360-frames JSON,
   which is now {base, frames} compact form — full-URL arrays still supported).
   Block 2: Okendo review rail; the product id comes from #apdp[data-oke-pid]. */
(function () {
  var root = document.getElementById('apdp');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* entrance */
  var targets = root.querySelectorAll('.apdp-anim');
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
  } else { targets.forEach(function (t) { t.classList.add('is-in'); }); }

  /* VIDEO HERO — autoplay + loop; the three chapters cross-fade on the
     video's OWN timeline, so nothing depends on scrolling. Reduced-motion:
     poster frame + first chapter, no autoplay. */
  (function(){
    var wrap = document.getElementById('apdp-vhero'); if(!wrap) return;
    var vid = document.getElementById('apdp-vhero-video');
    var states = wrap.querySelectorAll('.apdp-vstate');
    var dots = wrap.querySelectorAll('.apdp-vdots span');
    var last = 0;
    function setState(s){
      s = Math.max(0, Math.min(states.length - 1, s));
      last = s;
      states.forEach(function(el,i){ el.classList.toggle('on', i===s); });
      dots.forEach(function(el,i){ el.classList.toggle('on', i===s); });
    }
    setState(0);
    /* THREE-STEP copy control — the three text chapters advance in exactly
       three steps via the dots, the down-arrow, or a downward scroll. The
       video underneath just keeps looping, so it never stops or stutters. */
    dots.forEach(function(el,i){
      el.setAttribute('role','button'); el.setAttribute('tabindex','0'); el.setAttribute('aria-label','Chapter '+(i+1));
      el.addEventListener('click', function(){ setState(i); });
      el.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); setState(i); } });
    });
    var stepBtn = document.getElementById('apdp-vhero-step');
    if (stepBtn) stepBtn.addEventListener('click', function(e){
      if (last < states.length - 1) { e.preventDefault(); setState(last + 1); }
      /* on the final step the anchor falls through and scrolls to #apdp-buy */
    });
    if (reduced) return;
    /* video: uniform autoplay + loop — never scrubbed, never frozen */
    vid.muted = true; vid.loop = true;
    var pp = vid.play(); if (pp && pp.catch) pp.catch(function(){});
    ['click','touchstart'].forEach(function(ev){
      window.addEventListener(ev, function once(){ vid.play().catch(function(){}); window.removeEventListener(ev, once); }, {passive:true, once:true});
    });
    /* a downward scroll while the hero owns the viewport advances one chapter;
       after the third chapter the page scrolls on as normal (desktop only) */
    if (window.matchMedia && window.matchMedia('(min-width:1024px)').matches) {
      var lock = false, acc = 0;
      wrap.addEventListener('wheel', function(e){
        var r = wrap.getBoundingClientRect();
        if (r.top < -4 || r.bottom < window.innerHeight * 0.6) return; /* only while hero owns the view */
        var down = e.deltaY > 0, up = e.deltaY < 0;
        if (!down && !up) return;
        if (down && last >= states.length - 1) return;     /* past last chapter: page scrolls down */
        if (up && last <= 0) return;                        /* before first chapter: page scrolls up */
        e.preventDefault();
        if (lock) return;
        if (down && acc < 0) acc = 0;
        if (up && acc > 0) acc = 0;
        acc += e.deltaY;
        if (acc > 45) { acc = 0; lock = true; setState(last + 1); setTimeout(function(){ lock = false; }, 620); }
        else if (acc < -45) { acc = 0; lock = true; setState(last - 1); setTimeout(function(){ lock = false; }, 620); }
      }, {passive:false});
    }
  })();

  /* thumbs swap the buy-box stage */
  var stageMain = document.getElementById('apdp-stage-main');
  root.querySelectorAll('#apdp-thumbs button').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('#apdp-thumbs button').forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on'); stageMain.src = b.dataset.full;
    });
  });


  /* purchase plan cards: one-time first; refill enables the native selling plan */
  (function(){
    var plans = document.getElementById('apdp-plans2');
    var sp = document.getElementById('apdp-sp');
    var atcPrice = document.getElementById('apdp-atc-price');
    var priceTop = document.getElementById('apdp-price');
    var freq = document.getElementById('apdp-freq');
    var basePrice = atcPrice ? atcPrice.textContent : (priceTop ? priceTop.textContent : '');
    var ribbon = document.getElementById('apdp-ribbon');
    var refillPrice = document.getElementById('apdp-refill-price');
    var stickyPrice = document.getElementById('apdp-sticky-atc-price');
    function setPrice(p){ if (atcPrice) atcPrice.textContent = p; if (priceTop) priceTop.textContent = p; if (stickyPrice) stickyPrice.textContent = p; }
    function markCard(label){ if (!plans) return; plans.querySelectorAll('.apdp-plan2').forEach(function(l){ var on = l===label; l.classList.toggle('on', on); var r=l.querySelector('input'); if(r) r.checked=on; }); }
    function applyFreq(btn){
      if (!freq || !btn) return;
      freq.querySelectorAll('.apdp-freq-btn').forEach(function(x){ x.classList.toggle('on', x===btn); });
      var price = btn.getAttribute('data-price'), base = btn.getAttribute('data-base'), pct = btn.getAttribute('data-pct');
      sp.disabled = false; sp.value = btn.getAttribute('data-sp') || '';
      setPrice(price);
      if (refillPrice) refillPrice.innerHTML = (base && base !== price ? '<s>'+base+'</s> ' : '') + price;
      if (ribbon && pct) { var svTpl = ribbon.getAttribute('data-save-tpl') || 'Save [p]%'; ribbon.textContent = svTpl.replace('[p]', pct.replace(/\.0$/,'')); }
    }
    function selectMode(label){
      if (!plans) return;
      markCard(label);
      if (label.getAttribute('data-mode') === 'refill'){
        sp.disabled = false;
        if (freq){ freq.classList.add('show'); applyFreq(freq.querySelector('.apdp-freq-btn.on') || freq.querySelector('.apdp-freq-btn')); }
        else { sp.value = label.getAttribute('data-sp') || ''; setPrice(label.getAttribute('data-price') || basePrice); }
      } else {
        sp.disabled = true; sp.value = '';
        if (freq) freq.classList.remove('show');
        setPrice(basePrice);
      }
    }
    if (plans){
      plans.querySelectorAll('.apdp-plan2').forEach(function(l){ l.addEventListener('click', function(){ selectMode(l); }); });
      if (freq) freq.addEventListener('click', function(e){ var b=e.target.closest('.apdp-freq-btn'); if(!b) return; markCard(plans.querySelector('.apdp-plan2[data-mode="refill"]')); freq.classList.add('show'); applyFreq(b); });
      var init = plans.querySelector('.apdp-plan2.on') || plans.querySelector('.apdp-plan2'); if (init) selectMode(init);
      if (ribbon) ribbon.textContent = ribbon.textContent.replace(/\.0%$/,'%');
    }
    /* add-to-cart: AJAX add, then open the theme's (Recharge) cart drawer —
       the same slide-in that opens elsewhere on the store */
    var form = document.getElementById('apdp-form'), atc = document.getElementById('apdp-atc');
    function openCartDrawer(){
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function'){
        var ru = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(ru + '?sections=cart-drawer,cart-icon-bubble')
          .then(function(r){ return r.json(); })
          .then(function(sections){ cd.renderContents({ sections: sections }); })
          .catch(function(){ cd.open(); });
        return true;
      }
      var r = document.querySelector('[data-recharge-cart-trigger-observer]');
      if (r){ r.click(); return true; }
      var c = document.querySelector('[data-cart-drawer-trigger]') || document.querySelector('[aria-controls*="cart" i]') || document.querySelector('.cart-link, .header__icon--cart, .header__icon-cart') || document.querySelector('a[href$="/cart"]');
      if (c){ c.click(); return true; }
      return false;
    }
    if (form && atc) form.addEventListener('submit', function(e){
      e.preventDefault();
      var t = atc.querySelector('.apdp-atc-txt'), lbl = t ? t.textContent : '';
      if (t) t.textContent = (atc.getAttribute('data-adding') || 'Adding…'); atc.classList.add('is-loading');
      function done(){ atc.classList.remove('is-loading'); if (t) t.textContent = lbl; }
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:new FormData(form) })
        .then(function(res){ if(!res.ok) throw new Error('add'); return res.json(); })
        .then(function(){ done(); document.dispatchEvent(new CustomEvent('cart:refresh')); if(!openCartDrawer()){ window.location.href = rootUrl + 'cart'; } })
        .catch(function(){ done(); form.submit(); });
    });
  })();


  /* explorer capsules — click + full keyboard/screen-reader support */
  var expStage = document.getElementById('apdp-exp-stage');
  root.querySelectorAll('.apdp-cap').forEach(function(cap, ci){
    var head = cap.querySelector('.head'), body = cap.querySelector('.body');
    if (head){
      head.setAttribute('role','button');
      head.setAttribute('tabindex','0');
      head.setAttribute('aria-expanded', cap.classList.contains('on') ? 'true' : 'false');
      if (body){ if(!body.id) body.id = 'apdp-cap-body-' + ci; head.setAttribute('aria-controls', body.id); }
    }
    function openCap(){
      root.querySelectorAll('.apdp-cap').forEach(function(c){
        c.classList.remove('on');
        var h = c.querySelector('.head'); if (h) h.setAttribute('aria-expanded','false');
      });
      cap.classList.add('on');
      if (head) head.setAttribute('aria-expanded','true');
      if (!expStage) return;
      var imgs = expStage.querySelectorAll('img');
      imgs.forEach(function(im){ im.classList.remove('on'); });
      var i = parseInt(cap.dataset.img, 10); if (imgs[i]) imgs[i].classList.add('on');
    }
    cap.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest('.apdp-ritual-add, .apdp-ritual-link')) return;
      openCap();
    });
    if (head) head.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){ e.preventDefault(); openCap(); }
    });
  });

  /* night-ritual add-to-cart (same slide-in cart used by the main ATC) */
  function apdpOpenCart(){
    var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function'){
        var ru = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(ru + '?sections=cart-drawer,cart-icon-bubble')
          .then(function(r){ return r.json(); })
          .then(function(sections){ cd.renderContents({ sections: sections }); })
          .catch(function(){ cd.open(); });
        return true;
      }
      var r = document.querySelector('[data-recharge-cart-trigger-observer]'); if (r){ r.click(); return true; }
    var c = document.querySelector('[data-cart-drawer-trigger]') || document.querySelector('[aria-controls*="cart" i]') || document.querySelector('.cart-link, .header__icon--cart, .header__icon-cart') || document.querySelector('a[href$="/cart"]');
    if (c){ c.click(); return true; }
    return false;
  }
  root.querySelectorAll('.apdp-ritual-add').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute('data-variant');
      if (!id || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items:[{ id: parseInt(id, 10), quantity: 1 }] }) })
        .then(function(res){ if(!res.ok) throw new Error('add'); return res.json(); })
        .then(function(){ btn.classList.remove('is-loading'); btn.classList.add('is-added'); document.dispatchEvent(new CustomEvent('cart:refresh')); if(!apdpOpenCart()){ window.location.href = rootUrl + 'cart'; } setTimeout(function(){ btn.classList.remove('is-added'); }, 1800); })
        .catch(function(){ btn.classList.remove('is-loading'); window.location.href = rootUrl + 'cart'; });
    });
  });

  /* review carousel */
  (function(){
    var rail = root.querySelector('[data-rev-rail]');
    if(!rail) return;
    var cards = rail.querySelectorAll('.apdp-rev-card');
    if(!cards.length) return;
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    var dotsWrap = root.querySelector('[data-rev-dots]');
    function step(){
      var c = rail.querySelector('.apdp-rev-card');
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap || 18) || 18;
      return c ? c.getBoundingClientRect().width + gap : rail.clientWidth * 0.9;
    }
    var dots = [];
    if(dotsWrap){
      cards.forEach(function(_, i){
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'apdp-rev-dot'; d.setAttribute('aria-label', 'Go to review ' + (i+1));
        d.addEventListener('click', function(){ rail.scrollTo({ left: Math.round(step() * i), behavior: 'smooth' }); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function update(){
      var max = rail.scrollWidth - rail.clientWidth - 1;
      if(prev) prev.disabled = rail.scrollLeft <= 2;
      if(next) next.disabled = rail.scrollLeft >= max;
      var idx = Math.round(rail.scrollLeft / step());
      if(idx < 0) idx = 0; if(idx > dots.length - 1) idx = dots.length - 1;
      dots.forEach(function(d, i){ d.classList.toggle('on', i === idx); });
    }
    if(prev) prev.addEventListener('click', function(){ rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if(next) next.addEventListener('click', function(){ rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive:true});
    window.addEventListener('resize', update);
    var down=false, sx=0, sl=0, moved=false;
    rail.addEventListener('pointerdown', function(e){ if(e.pointerType==='mouse' && e.button!==0) return; down=true; moved=false; sx=e.clientX; sl=rail.scrollLeft; });
    rail.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4){ moved=true; rail.classList.add('drag'); } rail.scrollLeft = sl-dx; });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){ rail.addEventListener(ev, function(){ down=false; rail.classList.remove('drag'); }); });
    rail.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
    /* keyboard scrolling for the focusable rail */
    rail.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); rail.scrollBy({ left: step(), behavior:'smooth' }); }
      else if(e.key === 'ArrowLeft'){ e.preventDefault(); rail.scrollBy({ left: -step(), behavior:'smooth' }); }
    });
    update();
  })();

  /* Nature × Science: full-bleed particle WORLD MAP + unified origin/active filter */
  (function(){
    var nsx = root.querySelector('.apdp-nsx'); if (!nsx) return;
    /* ===== The Nine Aurora "Everywhere" — layered atmospheric environment (v2).
       Six distinct particle systems + an atmosphere quad matching the Shopify
       Editions reference: lavender-grey sky/fog with a pink-lilac bloom, a dense
       green terrain mound, vertical particle curtains, a DOMINANT central swirling
       sculptural band (spline/torus flow), a global multicolour field, and a sparse
       blurry foreground. Raw WebGL (no Three.js), no text. ===== */
    function initAuroraEverywhere(wrap, canvas, opts){
      opts = opts || {};
      var reduced = opts.reduced != null ? opts.reduced :
        (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      var destroyed=false, running=false, rafId=0, io=null, first=true;
      var W=0,H=0,dpr=1, reveal=0, revealTarget=0, t0=null, tNow=0;
      var listeners=[];
      /* pointer interaction state (canvas-pixel space). No DOM layout on move:
         the wrap rect is cached and refreshed on resize/scroll/enter only. */
      var ptr={x:0,y:0,vx:0,vy:0,active:false,lastT:0,lastMove:-1e9,speedNorm:0};
      var pStrength=0, pVelX=0, pVelY=0, touchDrag=false;
      var rectC={left:0,top:0};
      var TRN=6, tX=new Float32Array(TRN), tY=new Float32Array(TRN),
          tAge=new Float32Array(TRN), tBase=new Float32Array(TRN), tLife=new Float32Array(TRN),
          tHead=0, tAcc=0, trailFlat=new Float32Array(TRN*2), trailStrFlat=new Float32Array(TRN);
      var lastTs=null;
      function refreshRect(){ var r=wrap.getBoundingClientRect(); rectC.left=r.left; rectC.top=r.top; }
      function on(el,ev,fn,o){ el.addEventListener(ev,fn,o); listeners.push([el,ev,fn,o]); }

      var gl=null;
      try{ gl=canvas.getContext('webgl',{alpha:true,premultipliedAlpha:false,antialias:true,depth:false})
          || canvas.getContext('experimental-webgl',{alpha:true,premultipliedAlpha:false,antialias:true,depth:false}); }catch(e){}
      if(!gl) return {ok:false, destroy:function(){}};

      /* ---------- LAYER 1: atmosphere quad (sky/fog/bloom/terrain haze) ---------- */
      var bgVS='attribute vec2 aP; varying vec2 vUv; void main(){ vUv=aP*0.5+0.5; gl_Position=vec4(aP,0.0,1.0); }';
      var bgFS=[
        'precision highp float; varying vec2 vUv; uniform float uTime; uniform vec2 uCam;',
        'float hash(vec2 p){ return fract(sin(dot(p,vec2(41.3,289.1)))*43758.5453); }',
        'float noise(vec2 p){ vec2 i=floor(p),f=fract(p); f=f*f*(3.0-2.0*f);',
        '  float a=hash(i),b=hash(i+vec2(1,0)),c=hash(i+vec2(0,1)),d=hash(i+vec2(1,1));',
        '  return mix(mix(a,b,f.x),mix(c,d,f.x),f.y); }',
        'float fbm(vec2 p){ float v=0.0,a=0.5; for(int i=0;i<4;i++){ v+=a*noise(p); p*=2.0; a*=0.5; } return v; }',
        'void main(){ vec2 uv=vUv+uCam*0.4; float y=uv.y;',                       // y:0 bottom .. 1 top
        '  vec3 skyLo=vec3(0.52,0.49,0.57), skyHi=vec3(0.66,0.60,0.68);',         // lavender-grey
        '  vec3 col=mix(skyLo, skyHi, smoothstep(0.25,1.0,y));',
        '  float g=smoothstep(0.42,0.0,y);',                                       // green ground haze (taller)
        '  col=mix(col, vec3(0.26,0.42,0.20), g*0.95);',
        '  float db=distance(uv, vec2(0.62,0.80));',                              // pink-lilac bloom (upper c-r)
        '  col=mix(col, vec3(0.90,0.62,0.80), smoothstep(0.46,0.0,db)*0.7);',
        '  col=mix(col, vec3(1.0,0.94,0.98), smoothstep(0.18,0.0,db)*0.55);',
        '  float f=fbm(uv*2.4+vec2(uTime*0.012,uTime*0.006));',                    // volumetric fog
        '  col=mix(col, vec3(0.80,0.78,0.86), (f-0.5)*0.24);',
        '  col=mix(col, vec3(0.40,0.5,0.30), smoothstep(0.4,0.05,y)*fbm(uv*3.0-uTime*0.01)*0.20);', // green contamination
        '  gl_FragColor=vec4(col,1.0); }'
      ].join('\n');

      /* ---------- particle program (all six systems) ---------- */
      var pVS=[
        'precision highp float;',
        'attribute vec2 aHome; attribute vec3 aColor; attribute vec4 aMisc; attribute vec2 aExtra;', // depth,size,phase,sys | pathU,tubeAng
        'uniform vec2 uRes; uniform float uTime,uDPR,uReveal; uniform vec2 uCam;',
        'uniform vec2 uPointer; uniform vec2 uPointerVel; uniform float uPointerStrength,uPointerRadius,uPushPx,uMaxPx;',
        'uniform vec2 uTrail[6]; uniform float uTrailStr[6];',
        'varying vec3 vCol; varying float vA;',
        'const float TAU=6.2831853;',
        'float hash(vec2 p){ return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453); }',
        'float noise(vec2 p){ vec2 i=floor(p),f=fract(p); f=f*f*(3.0-2.0*f);',
        '  float a=hash(i),b=hash(i+vec2(1,0)),c=hash(i+vec2(0,1)),d=hash(i+vec2(1,1));',
        '  return mix(mix(a,b,f.x),mix(c,d,f.x),f.y); }',
        'vec2 curl(vec2 p){ float e=0.09; float n1=noise(p+vec2(0.0,e)),n2=noise(p-vec2(0.0,e));',
        '  float n3=noise(p+vec2(e,0.0)),n4=noise(p-vec2(e,0.0)); return vec2(n1-n2,-(n3-n4))/(2.0*e); }',
        /* the central sculptural ribbon path (organic loop, not a clean ring) */
        'vec3 swirlPath(float u){ float a=u*TAU;',
        '  float ev=0.025*sin(uTime*0.06);',
        '  float x=0.5 + (0.29+ev)*cos(a) + 0.055*cos(a*2.0+1.0) + 0.03*sin(a*3.0);',      // wide flat sweep
        '  float y=0.505 + (0.145+ev)*sin(a) + 0.05*sin(a*2.0+0.6) - 0.035*cos(a*3.0) + 0.045*cos(a);', // tilt
        '  float z=sin(a+0.5)*0.85 + 0.2*sin(a*2.0); return vec3(x,y,z); }',
        'void main(){',
        '  float depth=aMisc.x, size=aMisc.y, phase=aMisc.z, sys=aMisc.w;',
        '  vec2 p=aHome; float dd=0.35+depth; float zf=0.0; float szMul=1.0; float aMul=1.0;',
        '  if(sys>2.5 && sys<3.5){',                                              // 3 = central swirl
        '    float u=aExtra.x + uTime*0.026 + 0.04*sin(uTime*0.05+phase*6.0);',
        '    vec3 pp=swirlPath(u); zf=pp.z;',
        '    float tr=(0.014+0.052*fract(phase*7.0))*(0.85+0.30*sin(uTime*0.22+phase*TAU));', // defined misty band
        '    p=pp.xy + vec2(cos(aExtra.y),sin(aExtra.y))*tr;',
        '    p+=curl(p*2.6+uTime*0.03)*0.018;',                                    // organic scatter
        '    szMul=1.05+zf*0.5; aMul=(0.66+0.30*(zf*0.5+0.5));',                   // dominant, depth-shaded, no white-out
        '  } else if(sys>0.5 && sys<1.5){',                                       // 1 = green terrain mound
        '    p+=curl(aHome*3.0+uTime*0.018)*0.012*dd; p.y+=sin(uTime*0.05+phase*TAU)*0.003;',
        '  } else if(sys>1.5 && sys<2.5){',                                       // 2 = vertical curtains
        '    p.x+=sin(uTime*0.07+phase*TAU+aHome.y*9.0)*0.010*dd;',
        '    p.y+=curl(aHome*2.0+uTime*0.02).y*0.030*dd;',
        '  } else if(sys>3.5){',                                                  // 4 = foreground
        '    p+=curl(aHome*1.6+uTime*0.05)*0.085*dd; szMul=1.9; aMul=0.38;',
        '  } else {',                                                            // 0 = global field
        '    p+=curl(aHome*2.3+vec2(uTime*0.03,uTime*0.02))*0.040*dd;',
        '    p+=curl(aHome*4.6-uTime*0.025+11.0)*0.018*dd;',
        '  }',
        '  p+=uCam*(0.25+depth*1.1);',
        '  vec2 px=p*uRes;',
        /* local pointer interaction: repulsion + tangential curl + velocity follow
           + a fading wake from recent cursor samples; all position-based (no
           per-particle state) so the scene springs back once influence fades. */
        '  float depthReact=mix(0.35,1.0,depth);',                                    // fg100 mid~70 bg35
        '  vec2 disp=vec2(0.0);',
        '  vec2 pv=uPointerVel; float pvm=length(pv);',
        '  vec2 vdir=pvm>0.001?pv/pvm:vec2(1.0,0.0); vec2 vprp=vec2(-vdir.y,vdir.x);',
        '  if(uPointerStrength>0.001){',
        '    vec2 dv=px-uPointer;',
        '    float al=dot(dv,vdir), pe=dot(dv,vprp);',                                 // velocity-aligned frame
        '    float dist=length(vec2(al*0.8, pe*1.4));',                                // ellipse: slightly longer along move, tighter across
        '    float infl=1.0-smoothstep(uPointerRadius*0.45,uPointerRadius,dist);',     // tight inner, quick falloff
        '    infl=infl*infl;',                                                         // strong center
        '    if(infl>0.0){',
        '      float dl=length(dv); vec2 dir=dl>0.001?dv/dl:vec2(0.0); vec2 tang=vec2(-dir.y,dir.x);',
        '      float cs=dot(tang,vdir)>=0.0?1.0:-1.0;',
        '      float mag=infl*depthReact*uPointerStrength;',
        '      disp+=dir*mag*uPushPx*0.6;',                                            // reduced radial repulsion
        '      disp+=tang*mag*uPushPx*0.85*cs;',                                       // stronger directional/tangential flow
        '      disp+=pv*infl*depthReact*uPointerStrength*1.35;',                       // stronger velocity follow (trail-like)
        '    }',
        '  }',
        '  for(int k=0;k<6;k++){',                                                     // shorter, tighter wake
        '    float ts=uTrailStr[k]; if(ts<=0.002) continue;',
        '    vec2 dvt=px-uTrail[k]; float d2=length(dvt);',
        '    float in2=1.0-smoothstep(uPointerRadius*0.30,uPointerRadius*0.78,d2); in2=in2*in2;',
        '    if(in2>0.0){ vec2 wd=d2>0.001?dvt/d2:vec2(0.0); vec2 wt=vec2(-wd.y,wd.x);',
        '      float m2=in2*ts*depthReact;',
        '      disp+=wd*m2*uPushPx*0.35; disp+=wt*m2*uPushPx*0.5; }',
        '  }',
        '  disp=clamp(disp,vec2(-uMaxPx),vec2(uMaxPx));',
        '  px+=disp;',
        '  vec2 clip=(px/uRes)*2.0-1.0; clip.y=-clip.y; gl_Position=vec4(clip,0.0,1.0);',
        '  gl_PointSize=size*szMul*(0.5+depth*1.25)*uDPR*mix(0.5,1.0,uReveal);',
        '  vCol=aColor; vA=(0.24+depth*0.62)*aMul*uReveal;',
        '}'
      ].join('\n');
      var pFS=[
        'precision highp float; varying vec3 vCol; varying float vA; uniform float uGlow;',
        'void main(){ vec2 c=gl_PointCoord-0.5; float d=length(c); float m=smoothstep(0.5,0.0,d);',
        '  float A=m*vA;',
        '  if(uGlow>0.5) gl_FragColor=vec4(vCol*A*0.32, 0.0);',   // colored bloom, never white-out
        '  else gl_FragColor=vec4(vCol, A); }'
      ].join('\n');

      function sh(ty,src){ var s=gl.createShader(ty); gl.shaderSource(s,src); gl.compileShader(s); return s; }
      function prog(vs,fs){ var p=gl.createProgram(); gl.attachShader(p,sh(gl.VERTEX_SHADER,vs)); gl.attachShader(p,sh(gl.FRAGMENT_SHADER,fs)); gl.linkProgram(p); return p; }
      var pBG,pP,uBG={},uP={}, quad, pbuf, count=0;
      function makeProg(){
        pBG=prog(bgVS,bgFS); ['uTime','uCam'].forEach(function(n){ uBG[n]=gl.getUniformLocation(pBG,n); });
        pP=prog(pVS,pFS); ['uRes','uTime','uDPR','uReveal','uCam','uPointer','uPointerVel','uPointerStrength','uPointerRadius','uPushPx','uMaxPx','uGlow'].forEach(function(n){ uP[n]=gl.getUniformLocation(pP,n); });
        uP.uTrail=gl.getUniformLocation(pP,'uTrail[0]'); uP.uTrailStr=gl.getUniformLocation(pP,'uTrailStr[0]');
        quad=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,quad); gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
        pbuf=gl.createBuffer();
      }

      /* ---------- palettes ---------- */
      var GREEN=[[0.30,0.50,0.22],[0.45,0.63,0.28],[0.20,0.40,0.18],[0.56,0.68,0.32],[0.38,0.55,0.24]];
      var PINK =[[0.94,0.60,0.80],[0.90,0.44,0.68],[0.98,0.82,0.90],[0.86,0.34,0.58]];
      var WHITE=[[0.97,0.96,0.99],[0.90,0.88,0.84]];
      var GREY =[[0.60,0.57,0.65],[0.72,0.68,0.75]];
      var OLIVE=[[0.60,0.55,0.32],[0.50,0.44,0.26]];
      var DARK =[[0.28,0.26,0.31],[0.34,0.30,0.28]];
      function pk(a){ return a[(Math.random()*a.length)|0]; }
      function grand(){ return (Math.random()+Math.random()+Math.random()-1.5)/1.5; }
      var STRIDE=11, D=null, swirlStart=0, swirlN=0;
      function push(arr,i,x,y,col,depth,size,sys,pathU,tubeA){
        var o=i*STRIDE; arr[o]=x; arr[o+1]=y; arr[o+2]=col[0]; arr[o+3]=col[1]; arr[o+4]=col[2];
        arr[o+5]=depth; arr[o+6]=size; arr[o+7]=Math.random(); arr[o+8]=sys; arr[o+9]=pathU||0; arr[o+10]=tubeA||0;
      }
      function build(){
        var m=(W<700)?0.42:(W<1100?0.68:1.0);
        /* full density on normal machines; ease off only on low-memory/low-core devices */
        var lowPower=(navigator.deviceMemory && navigator.deviceMemory<=4) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency<=4);
        if(lowPower) m*=0.55;
        var N={ global:Math.round(30000*m), terrain:Math.round(26000*m), curtains:Math.round(22000*m),
                swirl:Math.round(44000*m), fore:Math.round(1800*m) };
        var total=N.global+N.terrain+N.curtains+N.swirl+N.fore;
        D=new Float32Array(total*STRIDE); var i=0;

        /* LAYER 5 — global multicolour field */
        for(var g=0; g<N.global; g++){
          var x=Math.random(), y=Math.random();
          var r=Math.random(), col = r<0.24?pk(GREEN): r<0.42?pk(PINK): r<0.6?pk(WHITE): r<0.78?pk(GREY): r<0.9?pk(OLIVE):pk(DARK);
          push(D,i++, x,y, col, Math.pow(Math.random(),0.7), 1.0+Math.random()*2.2, 0);
        }
        /* LAYER 2 — green terrain mound (curved, volumetric, lower third) */
        for(var t=0; t<N.terrain; t++){
          var tx=Math.random();
          var hill=0.20 + 0.15*Math.sin(tx*3.1+0.4) + 0.06*Math.sin(tx*7.0) + 0.05*Math.sin(tx*13.0); // taller rolling mound
          var ty=Math.abs(grand())*hill;                                     // dense near bottom, thinning up
          if(Math.random()<0.55) ty=Math.random()*hill;
          var r2=Math.random(), col2 = r2<0.72?pk(GREEN): r2<0.85?pk(WHITE): r2<0.95?pk(PINK):pk(OLIVE);
          push(D,i++, tx, ty, col2, 0.2+Math.random()*0.7, 1.2+Math.random()*2.4, 1);
        }
        /* LAYER 3 — vertical curtains (several tall plumes) */
        var COLS=[0.10,0.24,0.76,0.90]; var CW=[0.045,0.05,0.05,0.045];
        for(var c=0; c<N.curtains; c++){
          var ci=(Math.random()*COLS.length)|0;
          var cx=COLS[ci]+grand()*CW[ci];
          var cy=0.18+Math.random()*0.8;
          var r3=Math.random(), col3 = r3<0.3?pk(GREY): r3<0.5?pk(WHITE): r3<0.7?pk(PINK): r3<0.88?pk(GREEN):pk(OLIVE);
          var fade=Math.min(1.0,(1.0-cy)*1.4+0.2);
          push(D,i++, Math.max(0,Math.min(1,cx)), cy, col3, 0.4+Math.random()*0.55, 1.2+Math.random()*2.4, 2);
        }
        /* LAYER 4 — CENTRAL SCULPTURAL SWIRL (dominant) */
        swirlStart=i; swirlN=N.swirl;
        for(var s=0; s<N.swirl; s++){
          var u=Math.random();
          var tubeA=Math.random()*Math.PI*2;
          var r4=Math.random(), col4 = r4<0.22?pk(GREEN): r4<0.50?pk(PINK): r4<0.72?pk(WHITE): r4<0.86?pk(GREY): r4<0.95?pk(OLIVE):pk(DARK);
          push(D,i++, 0.5,0.5, col4, 0.45+Math.random()*0.55, 1.8+Math.random()*2.6, 3, u, tubeA);
        }
        /* LAYER 6 — sparse blurry foreground */
        for(var fdx=0; fdx<N.fore; fdx++){
          var r5=Math.random(), col5 = r5<0.5?pk(WHITE): r5<0.75?pk(PINK):pk(GREY);
          push(D,i++, Math.random(), Math.random(), col5, 0.9+Math.random()*0.1, 3.0+Math.random()*3.2, 4);
        }
        count=i;
        gl.bindBuffer(gl.ARRAY_BUFFER,pbuf); gl.bufferData(gl.ARRAY_BUFFER,D,gl.STATIC_DRAW);
      }
      function bindP(){
        gl.bindBuffer(gl.ARRAY_BUFFER,pbuf); var fb=4, st=STRIDE*fb;
        var aHome=gl.getAttribLocation(pP,'aHome'), aColor=gl.getAttribLocation(pP,'aColor'), aMisc=gl.getAttribLocation(pP,'aMisc'), aExtra=gl.getAttribLocation(pP,'aExtra');
        gl.enableVertexAttribArray(aHome); gl.vertexAttribPointer(aHome,2,gl.FLOAT,false,st,0);
        gl.enableVertexAttribArray(aColor); gl.vertexAttribPointer(aColor,3,gl.FLOAT,false,st,2*fb);
        gl.enableVertexAttribArray(aMisc); gl.vertexAttribPointer(aMisc,4,gl.FLOAT,false,st,5*fb);
        gl.enableVertexAttribArray(aExtra); gl.vertexAttribPointer(aExtra,2,gl.FLOAT,false,st,9*fb);
      }
      function resize(){
        var r=wrap.getBoundingClientRect(); W=Math.max(1,r.width|0); H=Math.max(1,r.height|0);
        dpr=Math.min(window.devicePixelRatio||1,(W<700?1.2:1.5));
        canvas.width=Math.round(W*dpr); canvas.height=Math.round(H*dpr);
        canvas.style.width=W+'px'; canvas.style.height=H+'px'; refreshRect(); build();
      }
      function frame(ts){
        if(destroyed) return; if(t0==null) t0=ts; tNow=(ts-t0)/1000;
        var dt = (lastTs==null)?0.016:Math.min(0.05,Math.max(0.001,(ts-lastTs)/1000)); lastTs=ts;
        reveal += (revealTarget-reveal)*0.05;
        /* ---- pointer envelope, velocity & wake update (all typed-array math, no DOM) ---- */
        var moving = !reduced && ptr.active && (ts-ptr.lastMove) < 80;   // moved within last 80ms
        var sTarget = moving ? (0.45 + 0.55*ptr.speedNorm) : 0.0;         // slow≈0.45 .. fast≈1.0
        if(isTouch) sTarget *= 0.55;                                      // restrained on touch-drag
        if(sTarget>pStrength) pStrength += (sTarget-pStrength)*0.40;      // fast attack (no perceptible delay)
        else pStrength += (sTarget-pStrength)*Math.min(1, dt/1.0);        // ~1.0s release to rest
        var tvx = moving?ptr.vx:0, tvy = moving?ptr.vy:0;
        pVelX += (tvx-pVelX)*0.30; pVelY += (tvy-pVelY)*0.30;
        // drop a wake sample along the path at a fixed cadence (~10/s → ~1s span over 10 slots)
        tAcc += dt;
        if(moving && tAcc>=0.055){ tAcc=0;
          tX[tHead]=ptr.x; tY[tHead]=ptr.y; tAge[tHead]=0;
          tBase[tHead]=Math.max(0.35,pStrength); tLife[tHead]=0.35+0.35*ptr.speedNorm; // 350–700ms wake
          tHead=(tHead+1)%TRN;
        }
        for(var kt=0; kt<TRN; kt++){
          tAge[kt]+=dt; var life=tLife[kt];
          var s = (life>0) ? tBase[kt]*(1.0 - tAge[kt]/life) : 0.0;
          trailStrFlat[kt] = s>0?s:0.0;
          trailFlat[kt*2]=tX[kt]; trailFlat[kt*2+1]=tY[kt];
        }
        var cam = reduced ? [0,0] : [Math.sin(tNow*0.03)*0.010, Math.cos(tNow*0.024)*0.006];
        gl.viewport(0,0,canvas.width,canvas.height);
        gl.disable(gl.BLEND); gl.useProgram(pBG);
        gl.uniform1f(uBG.uTime, reduced?4.0:tNow); gl.uniform2f(uBG.uCam, cam[0],cam[1]);
        gl.bindBuffer(gl.ARRAY_BUFFER,quad); var aP=gl.getAttribLocation(pBG,'aP');
        gl.enableVertexAttribArray(aP); gl.vertexAttribPointer(aP,2,gl.FLOAT,false,0,0);
        gl.drawArrays(gl.TRIANGLES,0,6);
        gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.useProgram(pP);
        gl.uniform2f(uP.uRes,canvas.width,canvas.height); gl.uniform1f(uP.uTime,reduced?4.0:tNow);
        gl.uniform1f(uP.uDPR,dpr); gl.uniform1f(uP.uReveal,reduced?1.0:reveal);
        gl.uniform2f(uP.uCam,cam[0],cam[1]);
        gl.uniform2f(uP.uPointer,ptr.x,ptr.y);
        gl.uniform2f(uP.uPointerVel,pVelX,pVelY);
        gl.uniform1f(uP.uPointerStrength, reduced?0.0:pStrength);
        gl.uniform1f(uP.uPointerRadius, 90.0*dpr);
        gl.uniform1f(uP.uPushPx, 22.0*dpr);
        gl.uniform1f(uP.uMaxPx, 32.0*dpr);
        gl.uniform2fv(uP.uTrail, trailFlat);
        gl.uniform1fv(uP.uTrailStr, trailStrFlat);
        gl.uniform1f(uP.uGlow,0.0); bindP(); gl.drawArrays(gl.POINTS,0,count);
        /* faint additive bloom ONLY where the swirl overlaps the pink glow — keeps it
           luminous & atmospheric without the white-ring look (owner: no ring icon) */
        gl.blendFunc(gl.ONE, gl.ONE); gl.uniform1f(uP.uGlow,1.0); gl.drawArrays(gl.POINTS, swirlStart, swirlN);
        if(first){ first=false; if(opts.onFirstFrame) opts.onFirstFrame(); }
        if(reduced){ running=false; return; }
        rafId=requestAnimationFrame(frame);
      }
      function start(){ if(running||destroyed) return; running=true; revealTarget=1; t0=null; rafId=requestAnimationFrame(frame); }
      function stop(){ running=false; if(rafId) cancelAnimationFrame(rafId); rafId=0; }
      function init(){
        makeProg(); resize();
        if(reduced){ revealTarget=1; reveal=1; requestAnimationFrame(frame); return; }
        if('IntersectionObserver' in window){
          io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting) start(); else stop(); }); },{threshold:0.15});
          io.observe(wrap);
        } else start();
      }
      var rz; on(window,'resize',function(){ clearTimeout(rz); rz=setTimeout(function(){ if(!destroyed) resize(); },220); },{passive:true});
      on(document,'visibilitychange',function(){ if(document.hidden) stop(); else if(!reduced&&!destroyed) start(); });
      function feed(e){
        var nx=(e.clientX-rectC.left)*dpr, ny=(e.clientY-rectC.top)*dpr;
        var ts=(e.timeStamp!=null)?e.timeStamp:0;
        if(ptr.active){
          var d=Math.max(1, ts-ptr.lastT);              // ms since last sample
          var ivx=(nx-ptr.x)/d*16.0, ivy=(ny-ptr.y)/d*16.0;   // px per ~frame
          var MX=40.0*dpr;                               // clamp to avoid explosions
          ivx=Math.max(-MX,Math.min(MX,ivx)); ivy=Math.max(-MX,Math.min(MX,ivy));
          ptr.vx=ivx; ptr.vy=ivy; ptr.speedNorm=Math.min(1, Math.sqrt(ivx*ivx+ivy*ivy)/(28.0*dpr));
        }
        ptr.x=nx; ptr.y=ny; ptr.active=true; ptr.lastT=ts; ptr.lastMove=ts;
      }
      on(wrap,'pointermove',function(e){
        if(e.pointerType==='touch' && !touchDrag) return;   // touch reacts only while dragging
        feed(e);
      },{passive:true});
      on(wrap,'pointerenter',function(e){ if(e.pointerType==='touch') return; refreshRect(); ptr.lastT=e.timeStamp||0; },{passive:true});
      on(wrap,'pointerleave',function(){ ptr.active=false; ptr.speedNorm=0; ptr.vx=0; ptr.vy=0; },{passive:true}); // stop sampling; wake fades
      on(wrap,'pointerdown',function(e){ if(e.pointerType==='touch'){ touchDrag=true; refreshRect(); ptr.active=true; ptr.lastT=e.timeStamp||0; ptr.x=(e.clientX-rectC.left)*dpr; ptr.y=(e.clientY-rectC.top)*dpr; } },{passive:true});
      on(window,'pointerup',function(e){ if(e.pointerType==='touch'){ touchDrag=false; ptr.active=false; ptr.speedNorm=0; } },{passive:true});
      on(window,'scroll',function(){ refreshRect(); },{passive:true});
      on(canvas,'webglcontextlost',function(e){ e.preventDefault(); stop(); });
      on(canvas,'webglcontextrestored',function(){ first=true; makeProg(); resize(); if(!reduced) start(); else requestAnimationFrame(frame); });
      init();
      return { ok:true, destroy:function(){ destroyed=true; stop();
        try{ if(io) io.disconnect(); }catch(e){}
        listeners.forEach(function(l){ try{ l[0].removeEventListener(l[1],l[2],l[3]); }catch(e){} }); listeners=[];
        try{ if(pbuf) gl.deleteBuffer(pbuf); if(quad) gl.deleteBuffer(quad); if(pP) gl.deleteProgram(pP); if(pBG) gl.deleteProgram(pBG); }catch(e){}
      } };
    }

    /* boot near-viewport; reveal on first frame; reduced-motion keeps the static
       fallback image; supports Shopify theme-editor section load/unload */
    var flowApi = null;
    function bootFlow(){
      var wrap = document.getElementById('apdp-nsx-stage');
      var canvas = document.getElementById('apdp-nsx-canvas');
      if (!wrap || !canvas || flowApi) return;
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (rm) return;
      flowApi = initAuroraEverywhere(wrap, canvas, { onFirstFrame: function(){ canvas.classList.add('is-shown'); } });
      if (!flowApi || !flowApi.ok) flowApi = null;
    }
    bootFlow();
    function onSecLoad(e){ if (e.target && e.target.querySelector && e.target.querySelector('#apdp-nsx-stage')) bootFlow(); }
    function onSecUnload(e){ if (e.target && e.target.querySelector && e.target.querySelector('#apdp-nsx-stage')){ if(flowApi){ flowApi.destroy(); flowApi=null; } document.removeEventListener('shopify:section:load', onSecLoad); document.removeEventListener('shopify:section:unload', onSecUnload); } }
    document.addEventListener('shopify:section:load', onSecLoad);
    document.addEventListener('shopify:section:unload', onSecUnload);

    /* Nature / Science capsules → open the ingredient carousel below the banner */
    var caps = document.querySelectorAll('.apdp-nsx-cap');
    var deckwrap = document.getElementById('apdp-nsx-deckwrap');
    var deck = document.getElementById('apdp-nsx-deck');
    if (caps.length && deckwrap && deck) {
      /* phones: relocate the carousel below the banner (in normal flow); desktop/tablet keep it in-banner */
      var stage = document.getElementById('apdp-nsx-stage');
      var mqSmall = window.matchMedia('(max-width: 600px)');
      var placeDeck = function(){
        if (!stage) return;
        if (mqSmall.matches){
          if (deckwrap.parentNode === stage && stage.parentNode){ stage.parentNode.insertBefore(deckwrap, stage.nextSibling); }
          deckwrap.classList.add('apdp-nsx-deckwrap--below');
        } else {
          if (deckwrap.parentNode !== stage){ stage.appendChild(deckwrap); }
          deckwrap.classList.remove('apdp-nsx-deckwrap--below');
        }
      };
      placeDeck();
      if (mqSmall.addEventListener) mqSmall.addEventListener('change', placeDeck);
      else if (mqSmall.addListener) mqSmall.addListener(placeDeck);
      var setGroup = function(g){
        deck.querySelectorAll('.apdp-nc').forEach(function(card){
          var on = card.getAttribute('data-group') === g;
          card.classList.toggle('is-hidden', !on);
          if (on){ card.style.animation='none'; void card.offsetWidth; card.style.animation=''; }
        });
      };
      caps.forEach(function(cap){
        cap.addEventListener('click', function(){
          var g = cap.getAttribute('data-group');
          var already = cap.classList.contains('is-active');
          caps.forEach(function(x){ var on = (x===cap) && !already; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on?'true':'false'); });
          if (already){ deckwrap.classList.remove('is-open'); deckwrap.hidden = true; return; }
          setGroup(g);
          deckwrap.hidden = false; void deckwrap.offsetWidth; deckwrap.classList.add('is-open');
          deck.scrollLeft = 0;
          if (mqSmall.matches){ try { deckwrap.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(e){ deckwrap.scrollIntoView(); } }
        });
      });
      /* drag / wheel horizontal scroll on the rail */
      var dn=false, mv=false, sx=0, sl=0;
      deck.addEventListener('pointerdown', function(e){ if(e.pointerType==='mouse'){ dn=true; mv=false; sx=e.clientX; sl=deck.scrollLeft; deck.classList.add('is-dragging'); } });
      window.addEventListener('pointermove', function(e){ if(!dn) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) mv=true; deck.scrollLeft = sl-dx; });
      window.addEventListener('pointerup', function(){ dn=false; deck.classList.remove('is-dragging'); });
      deck.addEventListener('click', function(e){ if(mv){ e.preventDefault(); e.stopPropagation(); mv=false; } }, true);
      deck.addEventListener('wheel', function(e){
        if(Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var max = deck.scrollWidth - deck.clientWidth;
        /* let the page scroll once the rail hits its edge — never trap the wheel */
        if ((e.deltaY > 0 && deck.scrollLeft >= max - 1) || (e.deltaY < 0 && deck.scrollLeft <= 1)) return;
        deck.scrollLeft += e.deltaY; e.preventDefault();
      }, { passive:false });
    }
  })();

  /* clinical + consumer counters — count up both result sets */
  (function(){
    if (reduced || !('IntersectionObserver' in window)) return;
    var grids = document.querySelectorAll('.apdp-countup');
    grids.forEach(function(grid){
      var els = grid.querySelectorAll('b'), done = false;
      var io2 = new IntersectionObserver(function(en){
        if (!en[0].isIntersecting || done) return; done = true;
        els.forEach(function(el){
          var final = el.textContent.trim();
          var num = parseFloat(final.replace(/[^0-9.]/g,'')); if (isNaN(num)) return;
          var pre = final.indexOf('+')===0 ? '+' : '';
          var suf = /%\s*$/.test(final) ? '%' : '';
          var decimals = final.indexOf('.') > -1 ? 2 : 0;
          var t0=null;
          function step(ts){ if(!t0) t0=ts; var k=Math.min(1,(ts-t0)/1400); var eased=1-Math.pow(1-k,3);
            el.textContent = pre + (num*eased).toFixed(decimals) + suf;
            if (k<1) requestAnimationFrame(step); else el.textContent = final; }
          requestAnimationFrame(step);
        });
      },{threshold:.15, rootMargin:'0px 0px -8% 0px'});
      io2.observe(grid);
    });
  })();

  /* ===== turning serum — continuous 360° frame loop (homepage-style) ===== */
  (function(){
    var stage = document.getElementById('apdp-360');
    if (!stage) return;
    var canvas = stage.querySelector('.apdp-360-canvas');
    var hint = stage.querySelector('.apdp-360-hint');
    var srcEl = document.getElementById('apdp-360-frames');
    if (!canvas || !srcEl) return;
    var URLS = [];
    try {
      var srcData = JSON.parse(srcEl.textContent);
      if (Object.prototype.toString.call(srcData) === '[object Array]') {
        URLS = srcData;
      } else if (srcData && srcData.frames) {
        var srcBase = srcData.base || '';
        URLS = srcData.frames.map(function (f) { return /^https?:/.test(f) ? f : srcBase + f; });
      }
    } catch(e){ return; }
    if (!URLS.length) return;

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var N = URLS.length;
    var imgs = new Array(N), loaded = new Array(N), loadedCount = 0;
    var cur = 0;           /* fractional frame index for smooth auto-rotate */
    var W = 0, H = 0, rafId = 0, running = false, started = false;
    var dragging = false, dragMoved = false, lastX = 0, autoPaused = 0;
    var SPEED = 1000 / 22;  /* ~22fps → ~3.3s per full turn */

    function fit(img){
      var iw = img.naturalWidth || 1, ih = img.naturalHeight || 1;
      var s = Math.min(W / iw, H / ih);
      var dw = iw * s, dh = ih * s;
      return { dw:dw, dh:dh, ox:(W - dw) / 2, oy:(H - dh) / 2 };
    }
    function nearest(idx){
      var i = ((Math.round(idx) % N) + N) % N;
      if (loaded[i]) return i;
      /* fall back to the closest already-loaded frame */
      for (var d = 1; d < N; d++){
        var a = ((i - d) % N + N) % N, b = (i + d) % N;
        if (loaded[a]) return a;
        if (loaded[b]) return b;
      }
      return -1;
    }
    function paint(){
      var i = nearest(cur); if (i < 0) return;
      var img = imgs[i]; var f = fit(img);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, f.ox * dpr, f.oy * dpr, f.dw * dpr, f.dh * dpr);
    }
    function resize(){
      var r = stage.getBoundingClientRect();
      W = Math.max(1, r.width | 0); H = Math.max(1, r.height | 0);
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      if (loadedCount) paint();
    }
    var lastT = 0;
    function loop(t){
      if (!lastT) lastT = t;
      var dt = t - lastT; lastT = t;
      if (!dragging && (!autoPaused || t > autoPaused)){
        autoPaused = 0;
        cur += dt / SPEED;             /* one frame every SPEED ms */
        if (cur >= N) cur -= N;
      }
      paint();
      rafId = requestAnimationFrame(loop);
    }
    function startAnim(){
      if (running || reduced) return;
      running = true; lastT = 0; rafId = requestAnimationFrame(loop);
    }

    /* progressive load — first frame first, then fan out so a partial set
       already turns; each arrival repaints if we're waiting on it */
    function loadFrame(i){
      if (imgs[i]) return;
      var im = new Image(); im.decoding = 'async';
      im.onload = function(){ loaded[i] = true; loadedCount++;
        if (loadedCount === 1){ resize(); }
        else if (!running && !reduced){ /* keep waiting for enough to move */ }
        if (loadedCount >= Math.min(8, N) && !running) startAnim();
        if (reduced && loadedCount === 1) paint();
      };
      im.onerror = function(){ loaded[i] = false; };
      im.src = URLS[i];
      imgs[i] = im;
    }
    function loadAll(){
      if (started) return; started = true;
      loadFrame(0);
      /* reduced motion never animates: one frame is all that is ever painted */
      if (reduced) return;
      /* interleaved order for a quick even spread around the turn */
      var order = [];
      for (var step = Math.floor(N/2); step >= 1; step = Math.floor(step/2)){
        for (var k = step; k < N; k += step){ if (order.indexOf(k) < 0) order.push(k); }
        if (step === 1) break;
      }
      for (var j = 0; j < N; j++){ if (order.indexOf(j) < 0) order.push(j); }
      var qi = 0;
      (function pump(){
        var budget = 6;
        while (budget-- > 0 && qi < order.length){ loadFrame(order[qi++]); }
        if (qi < order.length) setTimeout(pump, 120);
      })();
    }

    /* only wake when scrolled into view */
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(en){
        en.forEach(function(e){
          if (e.isIntersecting){ loadAll(); if (!reduced) startAnim(); }
          else if (running){ cancelAnimationFrame(rafId); running = false; }
        });
      }, { threshold: 0.15 });
      io.observe(stage);
    } else { loadAll(); startAnim(); }

    /* drag to turn — pauses the auto-rotate briefly, then it resumes */
    function px(e){ return e.touches ? e.touches[0].clientX : e.clientX; }
    canvas.addEventListener('pointerdown', function(e){
      dragging = true; dragMoved = false; lastX = e.clientX;
      canvas.classList.add('grabbing');
      if (hint) hint.classList.add('gone');
      try { canvas.setPointerCapture(e.pointerId); } catch(_){}
    });
    canvas.addEventListener('pointermove', function(e){
      if (!dragging) return;
      var dx = e.clientX - lastX; lastX = e.clientX;
      if (Math.abs(dx) > 1) dragMoved = true;
      cur -= dx / Math.max(24, W / N * 2);   /* frames per pixel */
      cur = ((cur % N) + N) % N;
      paint();
    });
    function endDrag(e){
      if (!dragging) return;
      dragging = false; canvas.classList.remove('grabbing');
      autoPaused = 0; lastT = 0;
      try { canvas.releasePointerCapture(e.pointerId); } catch(_){}
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('pointerleave', endDrag);

    var rz3; window.addEventListener('resize', function(){ clearTimeout(rz3); rz3 = setTimeout(resize, 200); }, { passive:true });
  })();

  /* floating add-to-cart bar: appears once the main buy button is scrolled
     past; its button clicks the real Add-to-cart so the native cart drawer
     opens exactly as normal */
  (function(){
    var bar = document.getElementById('apdp-stickybar');
    var mainAtc = document.getElementById('apdp-atc');
    var sbtn = document.getElementById('apdp-sticky-atc');
    if (!bar || !mainAtc) return;
    if (sbtn) sbtn.addEventListener('click', function(){ mainAtc.click(); });
    var ticking = false;
    function check(){
      ticking = false;
      var r = mainAtc.getBoundingClientRect();
      /* show once the real Add-to-cart has scrolled above the viewport */
      var show = r.bottom < 8;
      bar.classList.toggle('show', show);
      /* the bar is only translated off-screen, so it must be inert while
         hidden or keyboard users tab onto an invisible Add-to-cart button */
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert','');
    }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(check); } }, { passive:true });
    window.addEventListener('resize', check, { passive:true });
    check();
  })();

  /* community stories rail — same drag/entrance behaviour as the homepage
     aurora-stories section (no video handling; these are images) */
  (function(){
    var root = document.querySelector('[data-yst-stories]'); if (!root) return;
    var rail = root.querySelector('[data-yst-rail]'); if (!rail) return;
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !rm){
      var cards = rail.querySelectorAll('.apdp-yst-card');
      for (var i=0;i<cards.length;i++) cards[i].style.transitionDelay = (Math.min(i,8)*0.07)+'s';
      new IntersectionObserver(function(en,obs){ en.forEach(function(e){ if(e.isIntersecting){ root.classList.add('is-in'); obs.disconnect(); } }); },{threshold:0.15}).observe(root);
      setTimeout(function(){ root.classList.add('is-in'); }, 1800); /* safety: never leave cards hidden */
    } else { root.classList.add('is-in'); }
    var down=false, moved=false, sx=0, sl=0;
    rail.addEventListener('pointerdown', function(e){ if(e.pointerType!=='mouse') return; down=true; moved=false; sx=e.clientX; sl=rail.scrollLeft; rail.classList.add('is-dragging'); });
    window.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; rail.scrollLeft=sl-dx; });
    window.addEventListener('pointerup', function(){ down=false; rail.classList.remove('is-dragging'); });
    rail.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } }, true);
    rail.addEventListener('wheel', function(e){
      if(Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = rail.scrollWidth - rail.clientWidth;
      /* release the wheel at the edges so the page keeps scrolling */
      if ((e.deltaY > 0 && rail.scrollLeft >= max - 1) || (e.deltaY < 0 && rail.scrollLeft <= 1)) return;
      rail.scrollLeft += e.deltaY; e.preventDefault();
    }, {passive:false});
    rail.addEventListener('keydown', function(e){ if(e.key==='ArrowRight'){ rail.scrollBy({left:320,behavior:'smooth'}); e.preventDefault(); } if(e.key==='ArrowLeft'){ rail.scrollBy({left:-320,behavior:'smooth'}); e.preventDefault(); } });
  })();
})();

/* --- Okendo review rail (was inline) --- */
(function(){
  var rail = document.querySelector('[data-rev-rail]'); if (!rail) return;
  var okePid = (document.getElementById('apdp') || {dataset:{}}).dataset.okePid;
  if (!okePid) return;
  var BASE = 'https://api.okendo.io/v1/stores/02fddaf4-178b-4369-90dd-bd03cb306d07/products/shopify-' + okePid;
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function card(r){
    var a = el('article','apdp-rev-card');
    var top = el('div','apdp-rev-card-top');
    var stars = el('span','apdp-rev-stars','★★★★★');
    stars.setAttribute('aria-label','Rated ' + r.rating + ' out of 5 stars');
    var d = new Date(r.dateCreated);
    top.appendChild(stars); top.appendChild(el('span','apdp-rev-date', MONTHS[d.getMonth()] + ' ' + d.getFullYear()));
    a.appendChild(top);
    if (r.title) a.appendChild(el('h3','apdp-rev-title', r.title.trim()));
    if (r.body) a.appendChild(el('p','apdp-rev-body', r.body.trim()));
    var media = (r.media || []).filter(function(m){ return m.type === 'image'; }).slice(0, 3);
    if (media.length){
      var ph = el('div','apdp-rev-photos');
      media.forEach(function(m){
        var img = document.createElement('img');
        img.src = m.largePortraitThumbnailUrl || m.thumbnailUrl; img.loading = 'lazy';
        img.width = 62; img.height = 78;
        img.alt = 'Photo from ' + ((r.reviewer && r.reviewer.displayName) || 'a customer') + "'s review";
        ph.appendChild(img);
      });
      a.appendChild(ph);
    }
    var foot = el('div','apdp-rev-foot');
    var name = (r.reviewer && r.reviewer.displayName) || 'Verified customer';
    var initials = name.split(/\s+/).map(function(w){ return w.charAt(0); }).join('').replace(/[^A-Za-z]/g,'').slice(0,2).toUpperCase() || 'A';
    foot.appendChild(el('span','apdp-rev-avatar', initials));
    var who = el('span','apdp-rev-who');
    who.appendChild(el('span','apdp-rev-name', name));
    if (r.reviewer && r.reviewer.isVerified){
      who.appendChild(document.createElement('br'));
      var v = el('span','apdp-rev-verified');
      v.innerHTML = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#EB5D5B"/><path d="M4.6 8.2l2.1 2.1 4-4.4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      v.appendChild(document.createTextNode('Verified Buyer'));
      who.appendChild(v);
    }
    foot.appendChild(who); a.appendChild(foot);
    return a;
  }
  fetch(BASE + '/reviews?limit=12&orderBy=date%20desc')
    .then(function(res){ return res.ok ? res.json() : Promise.reject(res.status); })
    .then(function(j){
      var rs = (j.reviews || []).filter(function(r){ return r.status === 'approved' || !r.status; });
      if (!rs.length) return;
      rail.textContent = '';
      rs.forEach(function(r){ rail.appendChild(card(r)); });
    }).catch(function(){ /* server-rendered cards stay */ })
  fetch(BASE + '/review_aggregate')
    .then(function(res){ return res.ok ? res.json() : Promise.reject(res.status); })
    .then(function(j){
      var agg = j.reviewAggregate || j;
      var n = agg.reviewCount, c = document.querySelector('.apdp-rev-summary-count');
      if (c && n) c.textContent = n + ' verified review' + (n === 1 ? '' : 's');
    }).catch(function(){});
})();
